import { useState, useEffect } from "react"; // Added useEffect
import { motion, AnimatePresence } from "framer-motion";
import { Helmet } from "react-helmet";
import "./PhotoGallery.css"; // Your provided CSS file

// --- Data Structure for Photos by Section (Corrected Duplicate IDs) ---
const photoSections = {
  Speakers: [
    {
      id: "speaker1",
      src: "assets/images/gallery/year-2025/Speaker/Speaker-1.jpg",
      description: "",
    },
    {
      id: "speaker2",
      src: "assets/images/gallery/year-2025/Speaker/Speaker-2.jpg",
      description: "",
    },
    {
      id: "speaker3",
      src: "assets/images/gallery/year-2025/Speaker/Speaker-3.jpg",
      description: "",
    },
    {
      id: "speaker4",
      src: "assets/images/gallery/year-2025/Speaker/Speaker-4.jpg",
      description: "",
    },
    {
      id: "speaker5",
      src: "assets/images/gallery/year-2025/Speaker/Speaker-5.jpg",
      description: "",
    },
    {
      id: "speaker6",
      src: "assets/images/gallery/year-2025/Speaker/Speaker-6.jpg",
      description: "",
    },
    {
      id: "speaker7",
      src: "assets/images/gallery/year-2025/Speaker/Speaker-7.jpg",
      description: "",
    },
    {
      id: "speaker8",
      src: "assets/images/gallery/year-2025/Speaker/Speaker-8.jpg",
      description: "",
    },
    {
      id: "speaker9",
      src: "assets/images/gallery/year-2025/Speaker/Speaker-9.jpg",
      description: "",
    },
    {
      id: "speaker10",
      src: "assets/images/gallery/year-2025/Speaker/Speaker-10.jpg",
      description: "",
    },
    {
      id: "speaker11",
      src: "assets/images/gallery/year-2025/Speaker/Speaker-11.jpg",
      description: "",
    },
    {
      id: "speaker12",
      src: "assets/images/gallery/year-2025/Speaker/Speaker-12.jpg",
      description: "",
    },
    {
      id: "speaker13",
      src: "assets/images/gallery/year-2025/Speaker/Speaker-13.jpg",
      description: "",
    },
    {
      id: "speaker14",
      src: "assets/images/gallery/year-2025/Speaker/Speaker-14.jpg",
      description: "",
    },
    {
      id: "speaker15",
      src: "assets/images/gallery/year-2025/Speaker/Speaker-15.jpg",
      description: "",
    },
    {
      id: "speaker16",
      src: "assets/images/gallery/year-2025/Speaker/Speaker-16.jpg",
      description: "",
    },
    {
      id: "speaker17",
      src: "assets/images/gallery/year-2025/Speaker/Speaker-17.jpg",
      description: "",
    },
    {
      id: "speaker18",
      src: "assets/images/gallery/year-2025/Speaker/Speaker-18.jpg",
      description: "",
    },
  ],
  "Event Space": [
    {
      id: "space1",
      src: "assets/images/gallery/year-2025/Event-space/Event-space-1.jpg",
      description: "",
    },
    {
      id: "space2",
      src: "assets/images/gallery/year-2025/Event-space/Event-space-2.jpg",
      description: "",
    },
    {
      id: "space3",
      src: "assets/images/gallery/year-2025/Event-space/Event-space-3.jpg",
      description: "",
    },
    {
      id: "space4",
      src: "assets/images/gallery/year-2025/Event-space/Event-space-4.jpg",
      description: "",
    },
    {
      id: "space5",
      src: "assets/images/gallery/year-2025/Event-space/Event-space-5.jpg",
      description: "",
    },
  ],
  Networking: [
    {
      id: "networking1",
      src: "assets/images/gallery/year-2025/Networking/Networking-1.jpg",
      description: "",
    },
    {
      id: "networking2",
      src: "assets/images/gallery/year-2025/Networking/Networking-2.jpg",
      description: "",
    },
    {
      id: "networking3",
      src: "assets/images/gallery/year-2025/Networking/Networking-3.jpg",
      description: "",
    },
    {
      id: "networking4",
      src: "assets/images/gallery/year-2025/Networking/Networking-4.jpg",
      description: "",
    },
    {
      id: "networking5",
      src: "assets/images/gallery/year-2025/Networking/Networking-5.jpg",
      description: "",
    },
    {
      id: "networking6",
      src: "assets/images/gallery/year-2025/Networking/Networking-6.jpg",
      description: "",
    },
    {
      id: "networking7",
      src: "assets/images/gallery/year-2025/Networking/Networking-7.jpg",
      description: "",
    },
    {
      id: "networking8",
      src: "assets/images/gallery/year-2025/Networking/Networking-8.jpg",
      description: "",
    },
    {
      id: "networking9",
      src: "assets/images/gallery/year-2025/Networking/Networking-9.jpg",
      description: "",
    },
    {
      id: "networking10",
      src: "assets/images/gallery/year-2025/Networking/Networking-10.jpg",
      description: "",
    },
    {
      id: "networking11",
      src: "assets/images/gallery/year-2025/Networking/Networking-11.jpg",
      description: "",
    },
    {
      id: "networking12",
      src: "assets/images/gallery/year-2025/Networking/Networking-12.jpg",
      description: "",
    },
    {
      id: "networking13",
      src: "assets/images/gallery/year-2025/Networking/Networking-13.jpg",
      description: "",
    },
    {
      id: "networking14",
      src: "assets/images/gallery/year-2025/Networking/Networking-14.jpg",
      description: "",
    },
    {
      id: "networking15",
      src: "assets/images/gallery/year-2025/Networking/Networking-15.jpg",
      description: "",
    },
    {
      id: "networking16",
      src: "assets/images/gallery/year-2025/Networking/Networking-16.jpg",
      description: "",
    },
    {
      id: "networking17",
      src: "assets/images/gallery/year-2025/Networking/Networking-17.jpg",
      description: "",
    },
    {
      id: "networking18",
      src: "assets/images/gallery/year-2025/Networking/Networking-18.jpg",
      description: "",
    },
    {
      id: "networking19",
      src: "assets/images/gallery/year-2025/Networking/Networking-19.jpg",
      description: "",
    },
    {
      id: "networking20",
      src: "assets/images/gallery/year-2025/Networking/Networking-20.jpg",
      description: "",
    },
    {
      id: "networking21",
      src: "assets/images/gallery/year-2025/Networking/Networking-21.jpg",
      description: "",
    },
    {
      id: "networking22",
      src: "assets/images/gallery/year-2025/Networking/Networking-22.jpg",
      description: "",
    },
    {
      id: "networking23",
      src: "assets/images/gallery/year-2025/Networking/Networking-23.jpg",
      description: "",
    },
    {
      id: "networking24",
      src: "assets/images/gallery/year-2025/Networking/Networking-24.jpg",
      description: "",
    },
    {
      id: "networking25",
      src: "assets/images/gallery/year-2025/Networking/Networking-25.jpg",
      description: "",
    },
    {
      id: "networking26",
      src: "assets/images/gallery/year-2025/Networking/Networking-26.jpg",
      description: "",
    },
  ],
  Refreshment: [
    {
      id: "Refreshment1",
      src: "assets/images/gallery/year-2025/Refreshment/Refreshment-1.jpg",
      description: "",
    },
    {
      id: "Refreshment2",
      src: "assets/images/gallery/year-2025/Refreshment/Refreshment-2.jpg",
      description: "",
    },
    {
      id: "Refreshment3",
      src: "assets/images/gallery/year-2025/Refreshment/Refreshment-3.jpg",
      description: "",
    },
    {
      id: "Refreshment4",
      src: "assets/images/gallery/year-2025/Refreshment/Refreshment-4.jpg",
      description: "",
    },
    {
      id: "Refreshment5",
      src: "assets/images/gallery/year-2025/Refreshment/Refreshment-5.jpg",
      description: "",
    },
    {
      id: "Refreshment6",
      src: "assets/images/gallery/year-2025/Refreshment/Refreshment-6.jpg",
      description: "",
    },
    {
      id: "Refreshment7",
      src: "assets/images/gallery/year-2025/Refreshment/Refreshment-7.jpg",
      description: "",
    },
    {
      id: "Refreshment8",
      src: "assets/images/gallery/year-2025/Refreshment/Refreshment-8.jpg",
      description: "",
    },
  ],
  Registration: [
    {
      id: "registration1",
      src: "assets/images/gallery/year-2025/Registration/Registration-1.jpg",
      description: "",
    },
    {
      id: "registration2",
      src: "assets/images/gallery/year-2025/Registration/Registration-2.jpg",
      description: "",
    },
    {
      id: "registration3",
      src: "assets/images/gallery/year-2025/Registration/Registration-3.jpg",
      description: "",
    },
    {
      id: "registration4",
      src: "assets/images/gallery/year-2025/Registration/Registration-4.jpg",
      description: "",
    },
    {
      id: "registration5",
      src: "assets/images/gallery/year-2025/Registration/Registration-5.jpg",
      description: "",
    },
    {
      id: "registration6",
      src: "assets/images/gallery/year-2025/Registration/Registration-6.jpg",
      description: "",
    },
    {
      id: "registration7",
      src: "assets/images/gallery/year-2025/Registration/Registration-7.jpg",
      description: "",
    },
  ],
  Other: [
    {
      id: "other1",
      src: "assets/images/gallery/year-2025/other/other-1.jpg",
      description: "",
    },
    {
      id: "other2",
      src: "assets/images/gallery/year-2025/other/other-2.jpg",
      description: "",
    },
    {
      id: "other3",
      src: "assets/images/gallery/year-2025/other/other-3.jpg",
      description: "",
    },
    {
      id: "other4",
      src: "assets/images/gallery/year-2025/other/other-4.jpg",
      description: "",
    },
    {
      id: "other5",
      src: "assets/images/gallery/year-2025/other/other-5.jpg",
      description: "",
    },
    {
      id: "other6",
      src: "assets/images/gallery/year-2025/other/other-6.jpg",
      description: "",
    },
    {
      id: "other7",
      src: "assets/images/gallery/year-2025/other/other-7.jpg",
      description: "",
    },
    {
      id: "other8",
      src: "assets/images/gallery/year-2025/other/other-8.jpg",
      description: "",
    },
    {
      id: "other9",
      src: "assets/images/gallery/year-2025/other/other-9.jpg",
      description: "",
    },
    {
      id: "other10",
      src: "assets/images/gallery/year-2025/other/other-10.jpg",
      description: "",
    },
    {
      id: "other11",
      src: "assets/images/gallery/year-2025/other/other-11.jpg",
      description: "",
    },
    {
      id: "other12",
      src: "assets/images/gallery/year-2025/other/other-12.jpg",
      description: "",
    },
    {
      id: "other13",
      src: "assets/images/gallery/year-2025/other/other-13.jpg",
      description: "",
    },
    {
      id: "other14",
      src: "assets/images/gallery/year-2025/other/other-14.jpg",
      description: "",
    },
    {
      id: "other15",
      src: "assets/images/gallery/year-2025/other/other-15.jpg",
      description: "",
    },
    {
      id: "other16",
      src: "assets/images/gallery/year-2025/other/other-16.jpg",
      description: "",
    },
    {
      id: "other17",
      src: "assets/images/gallery/year-2025/other/other-17.jpg",
      description: "",
    },
    {
      id: "other18",
      src: "assets/images/gallery/year-2025/other/other-18.jpg",
      description: "",
    },
    {
      id: "other19",
      src: "assets/images/gallery/year-2025/other/other-19.jpg",
      description: "",
    },
    {
      id: "other20",
      src: "assets/images/gallery/year-2025/other/other-20.jpg",
      description: "",
    },
    {
      id: "other21",
      src: "assets/images/gallery/year-2025/other/other-21.jpg",
      description: "",
    },
    {
      id: "other22",
      src: "assets/images/gallery/year-2025/other/other-22.jpg",
      description: "",
    },
    {
      id: "other23",
      src: "assets/images/gallery/year-2025/other/other-23.jpg",
      description: "",
    },
    {
      id: "other24",
      src: "assets/images/gallery/year-2025/other/other-24.jpg",
      description: "",
    },
    {
      id: "other25",
      src: "assets/images/gallery/year-2025/other/other-25.jpg",
      description: "",
    },
    {
      id: "other26",
      src: "assets/images/gallery/year-2025/other/other-26.jpg",
      description: "",
    },
    {
      id: "other27",
      src: "assets/images/gallery/year-2025/other/other-27.jpg",
      description: "",
    },
    {
      id: "other28",
      src: "assets/images/gallery/year-2025/other/other-28.jpg",
      description: "",
    },
    {
      id: "other29",
      src: "assets/images/gallery/year-2025/other/other-29.jpg",
      description: "",
    },
    {
      id: "other30",
      src: "assets/images/gallery/year-2025/other/other-30.jpg",
      description: "",
    },
    {
      id: "other31",
      src: "assets/images/gallery/year-2025/other/other-31.jpg",
      description: "",
    },
    {
      id: "other32",
      src: "assets/images/gallery/year-2025/other/other-32.jpg",
      description: "",
    },
    {
      id: "other33",
      src: "assets/images/gallery/year-2025/other/other-33.jpg",
      description: "",
    },
    {
      id: "other34",
      src: "assets/images/gallery/year-2025/other/other-34.jpg",
      description: "",
    },
    {
      id: "other35",
      src: "assets/images/gallery/year-2025/other/other-35.jpg",
      description: "",
    },
    {
      id: "other36",
      src: "assets/images/gallery/year-2025/other/other-36.jpg",
      description: "",
    },
    {
      id: "other37",
      src: "assets/images/gallery/year-2025/other/other-37.jpg",
      description: "",
    },
    {
      id: "other38",
      src: "assets/images/gallery/year-2025/other/other-38.jpg",
      description: "",
    },
    {
      id: "other39",
      src: "assets/images/gallery/year-2025/other/other-39.jpg",
      description: "",
    },
    {
      id: "other40",
      src: "assets/images/gallery/year-2025/other/other-40.jpg",
      description: "",
    },
    {
      id: "other41",
      src: "assets/images/gallery/year-2025/other/other-41.jpg",
      description: "",
    },
  ],
};

// A flat array of all images for the "All" tab and modal functionality
const allImages = Object.values(photoSections).flat();

// Explicitly define the order of the tabs
const tabOrder = [
  "All",
  "Registration",
  "Speakers",
  "Event Space",
  "Networking",
  "Refreshment",
  "Other",
];

const AllPhoto2025 = () => {
  // Set the default active tab to "All"
  const [activeTab, setActiveTab] = useState("All");

  const title = " Photo Gallery 2025";
  const letterVariants = {
    hidden: { y: -50, opacity: 0 },
    visible: (index) => ({
      y: 0,
      opacity: 1,
      transition: { delay: index * 0.05, duration: 0.4, ease: "easeInOut" },
    }),
  };

  // Modal State
  const [modalOpen, setModalOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openModal = (imageSrc) => {
    const globalIndex = allImages.findIndex((img) => img.src === imageSrc);
    if (globalIndex !== -1) {
      setCurrentIndex(globalIndex);
      setModalOpen(true);
    }
  };

  const closeModal = () => setModalOpen(false);
  const showNext = () =>
    setCurrentIndex((prev) => (prev + 1) % allImages.length);
  const showPrev = () =>
    setCurrentIndex((prev) => (prev - 1 + allImages.length) % allImages.length);

  // --- Keyboard Navigation for Modal ---
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "ArrowRight") {
        showNext();
      } else if (event.key === "ArrowLeft") {
        showPrev();
      } else if (event.key === "Escape") {
        closeModal();
      }
    };

    // Add event listener only when the modal is open
    if (modalOpen) {
      window.addEventListener("keydown", handleKeyDown);
    }

    // Cleanup: remove the event listener when the modal is closed or component unmounts
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [modalOpen]); // Dependency array ensures this runs only when modalOpen changes

  // Animation variants for tab content and images
  const tabContentVariants = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0, transition: { duration: 0.5 } },
    exit: { opacity: 0, y: -20, transition: { duration: 0.3 } },
  };
  const imageVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: (i) => ({
      opacity: 1,
      scale: 1,
      transition: { delay: i * 0.08, duration: 0.4 },
    }),
  };

  const imagesToDisplay =
    activeTab === "All" ? allImages : photoSections[activeTab];

  return (
    <>
      <Helmet>
        <title>
          Welcome MSB Meet Photos | Money Service Business Advocacy UK
        </title>
        <meta
          name="description"
          content="View photos from the 2025 MSB Advocacy UK event, including pictures of speakers, Event space, networking, Refreshment, and more."
        />
        <meta
          property="og:title"
          content="Welcome MSB Meet Photos | Money Service Business Advocacy UK"
        />
        <meta
          property="og:description"
          content="A complete collection of photos from our 2025 event."
        />
        <meta property="og:type" content="website" />
      </Helmet>

      <main className="page_content">
        <section
          className="page_header text-center section_decoration"
          style={{ background: "#333" }}
        >
          <div className="container">
            <motion.h1
              className="page_title text-white"
              initial="hidden"
              animate="visible"
              style={{ display: "flex", justifyContent: "center" }}
            >
              {title.split("").map((letter, index) => (
                <motion.span
                  key={index}
                  custom={index}
                  variants={letterVariants}
                  style={{ display: "inline-block", whiteSpace: "pre" }}
                >
                  {letter}
                </motion.span>
              ))}
            </motion.h1>
          </div>
        </section>

        <section
          className="service_section section_space"
          style={{ overflow: "hidden" }}
        >
          <div className="container">
            <div className="tab-controls text-center">
              {tabOrder.map((tabName) => (
                <button
                  key={tabName}
                  className={`tab-button ${
                    activeTab === tabName ? "active" : ""
                  }`}
                  onClick={() => setActiveTab(tabName)}
                >
                  {tabName}
                </button>
              ))}
            </div>

            <AnimatePresence mode="wait">
              <motion.div
                key={activeTab}
                variants={tabContentVariants}
                initial="initial"
                animate="animate"
                exit="exit"
                className="row align-items-center"
              >
                {imagesToDisplay.map((item, index) => (
                  <motion.div
                    key={`${activeTab}-${item.id}`}
                    custom={index}
                    variants={imageVariants}
                    initial="hidden"
                    animate="visible"
                    className="col-lg-3 col-md-6 col-sm-6 col-6 d-flex justify-content-center"
                  >
                    <img
                      src={item.src}
                      alt={item.description || `${activeTab} - ${index + 1}`}
                      className="img-fluid gallery-thumb mb-4"
                      onClick={() => openModal(item.src)}
                    />
                  </motion.div>
                ))}
              </motion.div>
            </AnimatePresence>
          </div>

          {modalOpen && (
            <div className="modal-overlay" onClick={closeModal}>
              <div
                className="modal-content"
                onClick={(e) => e.stopPropagation()}
              >
                <img
                  src={allImages[currentIndex].src}
                  alt={
                    allImages[currentIndex].description ||
                    `Gallery Image ${currentIndex + 1}`
                  }
                  className="modal-image"
                />
                {allImages[currentIndex].description && (
                  <p className="modal-description">
                    {allImages[currentIndex].description}
                  </p>
                )}
                <button className="modal-close" onClick={closeModal}>
                  ×
                </button>
                <button className="modal-prev" onClick={showPrev}>
                  ❮
                </button>
                <button className="modal-next" onClick={showNext}>
                  ❯
                </button>
              </div>
            </div>
          )}
        </section>
      </main>
    </>
  );
};

export default AllPhoto2025;
